import { SET_RESTRICT_PUBLISH_ASSET } from '../../actions/dsr-actions-types'

const INITIAL_STATE_RESTRICT_PUBLISH_ASSET = { results: "" }

export function setRestrictPublishAssetReducer(state = INITIAL_STATE_RESTRICT_PUBLISH_ASSET, action) {
    switch (action.type) {
        case SET_RESTRICT_PUBLISH_ASSET:
            return { results: action.payload };
        default:
            return state;
    }
}